"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import OperationTypeWidget from "D5Utils/operation_widget/OperationTypeWidget";
import FieldsFactory from 'D5Utils/FieldsFactory';
import { System } from "Constants/objects";

var BaseFilterEditor =
/*#__PURE__*/
function () {
  /**
   * @var {string} type [number | string | date | datetime | select | boolean]
   * @var {string} fieldName
   * @var {string} defOperation ['=' | '<>' | '<' | '<=' | '>' | '>=' | 'contains' | 'between']
   * @var {any} value
   * @var {object} rest
   * {
   *   onOperationChanged: {function},
   *   onValueChanged: {function},
   * }
   *
   *
   */
  function BaseFilterEditor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BaseFilterEditor);

    var type = options.type,
        defOperation = options.defOperation;
    this._type = type;
    this.$_element = $("<div class='filter-field-container'/>");
    this._operationWidget = new OperationTypeWidget({
      type: this._type,
      id: props._id,
      operation: defOperation,
      subscribers: [this]
    });
    this.options = options;

    if (typeof this.options.onOperationChanged === 'function') {
      this.options.onOperationChanged = this.options.onOperationChanged.bind(this);
    }

    this.props = props;
    this.$field = null;
    this.currentType = this.getFieldType();
  }
  /**
   * @return {string} [number | numberTwin | text | date | dateTwin | select | multiSelect | bool | boolTable]
   */


  _createClass(BaseFilterEditor, [{
    key: "getFieldType",
    value: function getFieldType() {
      if (this._type === System.FIELD_EDITOR_TYPE.BOOL_SB || this._type === System.FIELD_EDITOR_TYPE.SELECT || this._type === System.FIELD_EDITOR_TYPE.MULTI_SELECT) {
        return this._type;
      }

      switch (this.operation()) {
        case '=':
        case '<>':
        case '<':
        case '>':
        case '<=':
        case '>=':
          return this._type;

        case 'contains':
          return System.FIELD_EDITOR_TYPE.TEXT;

        case 'between':
          return this._type === System.FIELD_EDITOR_TYPE.NUMBER ? System.FIELD_EDITOR_TYPE.NUMBER_TWIN : System.FIELD_EDITOR_TYPE.DATE_TWIN;

        case 'isanyof':
        case 'isnotanyof':
          return System.FIELD_EDITOR_TYPE.ANY_OF;

        default:
          return this.operation();
      }
    }
  }, {
    key: "onOperationChanged",
    value: function onOperationChanged(operation) {
      try {
        if (this.$field && this.typeChanged()) {
          this.currentType = this.getFieldType();
          this.$field.dispose();
          this.$_element.find('.d5-field').remove();
          this.props.value = undefined;
          this.$field = FieldsFactory.create(this.currentType, this.props);
          this.$field.element().appendTo(this.$_element.find('.d5-field-container'));
        }
      } catch (e) {
        console.error(e);
      }

      if (typeof this.options.onOperationChanged === 'function') {
        this.options.onOperationChanged(operation);
      }
    }
  }, {
    key: "render",
    value: function render() {
      try {
        if (this._operationWidget.element()) this._operationWidget.element().appendTo(this.$_element);
        this.$field = FieldsFactory.create(this.currentType, this.props);
        $('<div class="d5-field-container"/>').append(this.$field.element()).appendTo(this.$_element);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "typeChanged",
    value: function typeChanged() {
      return this.currentType !== this.getFieldType();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.$field.getValue();
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      this.$field.setValue(newValue);
    }
  }, {
    key: "element",
    value: function element() {
      return this.$_element;
    }
  }, {
    key: "operation",
    value: function operation(newOperation) {
      if (newOperation != null) {
        this._operationWidget && this._operationWidget.operation({
          itemData: {
            symbol: newOperation
          }
        });
        return;
      }

      return this._operationWidget && this._operationWidget.operation();
    }
  }, {
    key: "type",
    value: function type() {
      return this._type;
    }
  }]);

  return BaseFilterEditor;
}();

export { BaseFilterEditor as default };